import classNames from 'classnames';
import React from 'react';
import { Image, Selectable } from '@miro-site/ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MenuItem = function MenuItem(_ref) {
  var animationType = _ref.animationType,
      _ref$animationDelay = _ref.animationDelay,
      animationDelay = _ref$animationDelay === void 0 ? 0 : _ref$animationDelay,
      href = _ref.href,
      label = _ref.label,
      media = _ref.media,
      _ref$eventKey = _ref.eventKey,
      eventKey = _ref$eventKey === void 0 ? '' : _ref$eventKey,
      selected = _ref.selected,
      onSelect = _ref.onSelect;
  var IMAGE_WIDTH = 44;
  var IMAGE_HEIGHT = 44;
  return /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsx(Selectable, {
      className: classNames(animationType, 'text-decoration-none'),
      style: {
        '--animation-delay': animationDelay
      },
      fixedWidth: true,
      href: href,
      eventKey: eventKey,
      selected: selected,
      iconSize: "md",
      defaultIcon: !href ? 'ChevronRight' : undefined,
      onSelect: onSelect,
      size: "sm",
      children: /*#__PURE__*/_jsxs("div", {
        className: "d-flex gap-200",
        children: [(media === null || media === void 0 ? void 0 : media.url) && /*#__PURE__*/_jsx("div", {
          style: {
            width: "".concat(IMAGE_WIDTH, "px"),
            height: "".concat(IMAGE_HEIGHT, "px")
          },
          className: "rounded-50 border border-image-idle overflow-hidden",
          children: /*#__PURE__*/_jsx(Image, {
            priority: true,
            className: "align-self-center",
            alt: label || '',
            src: (media === null || media === void 0 ? void 0 : media.url) || '',
            width: IMAGE_WIDTH,
            height: IMAGE_HEIGHT
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "text-wrap align-self-center",
          children: "".concat(label).trim()
        })]
      })
    })
  });
};